// 접속 단말 플랫폼 감지 — 랜딩 앱설치 유도용.
// photo-organizer의 AppInstallGuidePage 규약과 동일한 판정을 쓴다(단일 SSOT는 아직 없어 규칙만 일치).
//
// iPadOS 13+ 는 UA 가 Macintosh 로 나오므로 터치 지원 여부(maxTouchPoints)를 함께 본다.
// 서버 렌더가 없는 SPA라 navigator 접근은 항상 안전하다.

export type Platform = 'android' | 'ios' | 'other';

export function detectPlatform(): Platform {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return 'android';
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
  return 'other';
}

/** 모바일 브라우저(Android/iOS) 여부 — 앱설치 버튼 노출 판정에 쓴다 */
export function isMobileBrowser(): boolean {
  return detectPlatform() !== 'other';
}
